import { useState, useEffect } from "react";
import MDBox from "ui/MDBox";
import MDTypography from "ui/MDTypography";
import MDInput from "ui/MDInput";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useParams } from 'react-router-dom';
import { Card, FormControl, FormGroup, FormControlLabel, Checkbox } from "@mui/material";
import Notification from "examples/Notifications";
import roleService from "services/role-service";
import { UpdateButton } from "layouts/common/buttons";

const EditRole = () => {
  const { id } = useParams();
  const [notification, setNotification] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const [rolesData, setRolesData] = useState({ name: '', permissions: [] });
  const [errors, setErrors] = useState({ nameError: false, permissionsError: false });
  const [loading, setLoading] = useState(false);

  const getRoleData = async () => {
    console.log("📡 getRoleData called"); // Function call confirmation
    try {
      const roleData = await roleService.get(id);
      console.log("📦 API response received:", roleData); // Full response

      if (roleData.success) {
        setRolesData({
          name: roleData.role.name,
          permissions: roleData.role.permissions || [],
        });
        console.log("✅ Role data set:", roleData.role);
      } else {
        console.error('❌ Failed to fetch role data:', roleData.message);
      }
    } catch (error) {
      console.error('🚫 API call failed:', error);
    }
  };


  useEffect(() => {
    getRoleData();
  }, []);

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const response = await roleService.getpermissions();
        console.log('Permissions API Response:', response);
        if (response.success) {
          setPermissions(response.permissions);
        } else {
          console.error('Error fetching permissions:', response.message);
        }
      } catch (error) {
        console.error('API call failed:', error);
      }
    };
    fetchPermissions();
  }, []);

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setRolesData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleCheckboxChange = (e) => {
    const { value } = e.target;
    setRolesData((prevData) => {
      const currentPermissions = prevData.permissions.includes(value)
        ? prevData.permissions.filter((permission) => permission !== value)
        : [...prevData.permissions, value];

      return { ...prevData, permissions: currentPermissions };
    });
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    setErrors({ nameError: false, permissionsError: false });

    if (rolesData.name.trim().length === 0) {
      setErrors((prev) => ({ ...prev, nameError: true }));
      return;
    }
    if (rolesData.permissions.length === 0) {
      setErrors((prev) => ({ ...prev, permissionsError: true }));
      return;
    }

    const newRoleData = { name: rolesData.name, permissions: rolesData.permissions };

    setLoading(true);
    try {
      const response = await roleService.update(id, newRoleData);
      if (response.success) {
        setNotification({ type: 'success', message: response.message });
        setRolesData({ name: '', permissions: [] });
      } else {
        setNotification({ type: 'error', message: response.message });
      }
    } catch (error) {
      console.error('API call failed:', error);
    }
    setLoading(false);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} pt={5} pb={3} />
      <Card>
        <MDBox
          mx={2}
          mt={-3}
          py={3}
          px={2}
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <MDTypography variant="h6" color="white">
            Edit Role
          </MDTypography>


          <UpdateButton loading={loading} onClick={submitHandler} />
        </MDBox>

        <MDBox component="form" role="form" onSubmit={submitHandler} display="flex" flexDirection="column" py={0} px={3}>
          <Notification notification={notification} setNotification={setNotification} />
          <MDBox display="flex" flexDirection="row" mt={5} mb={3}>
            <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="100%" mr={2}>
              <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                Name
              </MDTypography>
              <MDBox display="flex" flexDirection="column" width="100%" mr={2}>
                <MDInput
                  type="text"
                  name="name"
                  value={rolesData.name}
                  onChange={changeHandler}
                  error={errors.nameError}
                />
                {errors.nameError && (
                  <MDTypography variant="caption" color="error">
                    Name is required
                  </MDTypography>
                )}
              </MDBox>
            </MDBox>
          </MDBox>

          <MDBox p={2} mb={3}>
            <MDTypography variant="h6" mb={2}>
              Permissions
            </MDTypography>
            <FormControl error={errors.permissionsError}>
              <FormGroup>
                <MDBox display="flex" justifyContent="space-between" flexWrap="wrap" mb={2}>
                  {permissions.map((p) => {
                    const permission = typeof p === 'string' ? p : p.name; // normalize
                    return (
                      <FormControlLabel
                        key={permission}
                        control={
                          <Checkbox
                            checked={rolesData.permissions.includes(permission)}
                            onChange={handleCheckboxChange}
                            value={permission}
                          />
                        }
                        label={permission}
                        sx={{
                          width: '30%',
                          marginBottom: '16px',
                          border: 1,
                          borderColor: 'grey.300',
                          borderRadius: 2,
                          padding: 1,
                        }}
                      />
                    );
                  })}
                </MDBox>
              </FormGroup>
              {errors.permissionsError && (
                <MDTypography variant="caption" color="error">
                  Permissions are required
                </MDTypography>
              )}
            </FormControl>
          </MDBox>

          {/* <MDBox mb={2} display="flex" justifyContent="end">
         
          </MDBox> */}
        </MDBox>
      </Card>
    </DashboardLayout>
  );
};

export default EditRole;
